module.exports = __webpack_public_path__ + "static/media/5J1A6831_Small.8eaaa606.jpg";